import React, { Fragment, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { allData as data } from '../data/data';
import { PopupStyle } from '../styles/popup.style';
import { FaPlus, FaPlay, FaMinus } from 'react-icons/fa';

const Popup = ({ 
    index, 
    isOpen, 
    detailsIsOpen,
    loading, 
    onImgLoad, 
    onClose, 
    onDetailsToggle 
}) => {

    const [slideIndex, setSlideIndex] = useState(0);

    const popupElement = useRef('');


    const handleDetailsDisplay = () => {

        let popupDetails = popupElement.current;
        
        if(detailsIsOpen) {
            onDetailsToggle();
            popupDetails.style.maxHeight = `${0}px`;
            
        } else {
            onDetailsToggle();
            popupDetails.style.maxHeight = `${popupDetails.scrollHeight}px`;
            popupDetails.parentElement.scrollTo(0, popupDetails.offsetTop);
        }

    } 

    const handleNextSlide = () => {
        if(slideIndex === data[index].images.length - 1) {
            setSlideIndex(0)
        } else {
            setSlideIndex(slideIndex + 1);
        }
    }

    const handlePrevSlide = () => {
        if(slideIndex === 0) {
            setSlideIndex(data[index].images.length - 1);
        } else {
            setSlideIndex(slideIndex - 1);
        }
    }
    return (
        isOpen && (<PopupStyle className={ isOpen ? "portfolio-popup open" : "portfolio-popup"}>
            <div className={ detailsIsOpen ? "pp-details active" : "pp-details"} ref={popupElement}>
                <div className="pp-details-inner">
                    <div className="pp-title">
                        <h2>{data[index].title}</h2>
                        <p>category - <span className="pp-project-category">{data[index].details?.category}</span></p>
                    </div>
                    <div className="pp-project-details">
                        <div className="row">
                            <div className="description">
                                <h3>Project Summary:</h3>
                                <p>{data[index].details?.summary}</p>
                            </div>
                            <div className="info">
                                <h3>Project Info:</h3>
                                <ul>
                                    <li>
                                        Date - <span>{data[index].details?.projectInfo.date}</span>
                                    </li>
                                    <li>Client - <span>{data[index].details?.projectInfo.client}</span></li>
                                    <li>tools - <span>{data[index].details?.projectInfo.tools.join(', ')}</span></li>
                                    {data[index].codes && (<li>
                                        code - <span>
                                            {
                                                data[index].codes.map((code, idx) => (
                                                    <Link to={{pathname: `${code}`}}
                                                    target="_blank"
                                                    key={idx}
                                                    >View Code{idx + 1}</Link>
                                                ))
                                            }
                                        </span>
                                    </li>)}
                                    <li>
                                        site - <span>
                                            {
                                                data[index].details?.projectInfo.sites.map((site, idx) =>(
                                                    <Link to={{pathname: `${site}`}}
                                                    target="_blank"
                                                    key={idx}
                                                    >{`${data[index].details?.name[idx]}.com`}</Link>
                                                ))
                                            }
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pp-separator"></div>

            <div className="pp-main">
                <div className="pp__main--inner">
                    {data[index].details &&(<div 
                        className="pp-project__details--btn outside-shadow hover-in-shadow"
                        onClick={handleDetailsDisplay}
                    >Project Details { detailsIsOpen ? <FaMinus/> : <FaPlus/>}</div>)}
                    <div 
                        className="pp-close outside-shadow hover-in-shadow"
                        onClick={onClose}
                    >&times;</div>
                    <img 
                        src={data[index].images[slideIndex]} 
                        alt="project slides" 
                        className="pp__img outside-shadow" 
                        onLoad={onImgLoad}
                    />
                    <div className="pp-counter">{`${slideIndex + 1} of ${data[index].images.length}`}</div>
                    <div className={loading ? "pp-loader active" : "pp-loader"}>
                        <div></div>
                    </div>
                </div>
                {data[index].images.length > 1 &&(<Fragment>
                    <div className="pp-prev" onClick={handlePrevSlide}><FaPlay/></div>
                    <div className="pp-next" onClick={handleNextSlide}><FaPlay/></div>
                </Fragment>)}
            </div>
        </PopupStyle>)
    )
}

export default Popup
